import React from 'react';

export default ({ color = '#A3B2C9', size = 12 }: { color?: string; size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="6" cy="6" r="6" fill={color} />
    <path
      d="M5.66667 7.58333L4 8L4.41667 6.33333L7.75 3L9 4.25L5.66667 7.58333Z"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
